export var HttpMethods;
(function (HttpMethods) {
    HttpMethods["POST"] = "POST";
    HttpMethods["PUT"] = "PUT";
    HttpMethods["PATCH"] = "PATCH";
    HttpMethods["GET"] = "GET";
    HttpMethods["DELETE"] = "DELETE";
})(HttpMethods || (HttpMethods = {}));
